import React, { memo } from 'react';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    icon: '💰',
    title: 'Calculadora de Precios PRO',
    desc: 'Nunca más regales tu trabajo. Calculás tu costo exacto, tu margen y el precio final con esta guía.',
    value: '$23.000 ARS'
  }, {
    num: 2,
    icon: '🍮',
    title: 'Recetario Postres Rentables',
    desc: 'Más postres de alto margen para ampliar tu catálogo y ofrecer variedad sin aumentar costos.',
    value: '$18.000 ARS'
  }, {
    num: 3,
    icon: '📲',
    title: 'Instagram Vende Express',
    desc: 'Mini curso para convertir tu perfil en una máquina de pedidos. Qué publicar, cuándo y cómo.',
    value: '$30.000 ARS'
  }, {
    num: 4,
    icon: '🛒',
    title: 'Directorio de Proveedores',
    desc: 'Dónde comprar cada insumo al precio más bajo para maximizar tu margen desde el primer pedido.',
    value: '$15.000 ARS'
  }, {
    num: 5,
    icon: '✨',
    title: 'Pack 30 Stories Listas',
    desc: 'Plantillas diseñadas para vender en Stories. Publicás en 3 minutos con estilo profesional.',
    value: '$20.000 ARS'
  }, {
    num: 6,
    icon: '📸',
    title: 'Fotos Celular Estilo Pro',
    desc: 'Cómo sacar fotos que hacen agua la boca — solo con tu celular y luz natural. Sin cámara cara.',
    value: '$18.000 ARS'
  }, {
    num: 7,
    icon: '🚀',
    title: 'Ruta Negocio 7 Días',
    desc: '7 modelos de negocio reales con gelatinas: encargos, kits, clases, delivery. Empezás hoy mismo.',
    value: '$12.000 ARS'
  }, {
    num: 8,
    icon: '♾️',
    title: 'Actualizaciones Eternas',
    desc: 'Cada diseño nuevo que sumemos al método, lo recibís gratis automáticamente. Para siempre.',
    value: 'Invaluable',
    isSpecial: true
  }];
  return <section className="bg-bg py-16 px-5" data-id="element-15">
      <div className="container-custom" data-id="element-16">
        <span className="section-tag" data-id="element-17">Incluido gratis con tu compra</span>
        <h2 className="section-title" data-id="element-18">
          8 BONOS QUE VALEN
          <br data-id="element-19" />
          MÁS QUE EL CURSO
        </h2>
        <p className="section-sub" data-id="element-20">
          Si los vendieras por separado, estarían a +$180.000 ARS. Los recibís
          gratis hoy.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[18px] mb-10" data-id="element-21">
          {bonuses.map((bono, idx) => <div key={idx} className={`bg-card border rounded-xl p-6 relative transition-all duration-200 hover:-translate-y-[3px] ${bono.isSpecial ? 'border-gold bg-[rgba(245,200,66,0.06)] hover:border-gold' : 'border-border hover:border-pink'}`} data-id="element-22">
              <div className={`absolute top-3.5 right-4 font-bebas text-[36px] leading-none hidden sm:block ${bono.isSpecial ? 'text-gold opacity-30' : 'text-border'}`} data-id="element-23">
                {bono.num}
              </div>

              <span className="text-[28px] mb-3 block" data-id="element-24">{bono.icon}</span>
              <h4 className="font-bebas text-[18px] text-white tracking-[0.5px] mb-1.5 leading-[1.1]" data-id="element-25">
                {bono.title}
              </h4>
              <p className="text-[13px] text-muted mb-3.5 leading-[1.5]" data-id="element-26">
                {bono.desc}
              </p>

              <div className="flex items-center gap-2.5" data-id="element-27">
                <span className={`text-[13px] ${bono.isSpecial ? 'text-gold font-bold no-underline' : 'text-muted line-through'}`} data-id="element-28">
                  Valor: {bono.value}
                </span>
                <span className="bg-green text-white text-[11px] font-bold py-[3px] px-2.5 rounded-full tracking-[1px]" data-id="element-29">
                  {bono.isSpecial ? 'INCLUIDO' : 'GRATIS'}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}